import { useEffect, useRef } from 'react';
import { Card } from '../../../../components/ui/Card';

export function KPIBar({ filteredWorkOrders, chartJsLoaded }) {
    const canvasRef = useRef(null);
    const chartRef = useRef(null);

    useEffect(() => {
        if (!chartJsLoaded || !canvasRef.current || !filteredWorkOrders || filteredWorkOrders.length === 0) return;

        if (chartRef.current) {
            chartRef.current.destroy();
        }

        const ctx = canvasRef.current.getContext('2d');
        const labels = filteredWorkOrders.map(fwo => fwo.line);
        const data = filteredWorkOrders.map(fwo => fwo.workOrderStats?.total || 0);

        chartRef.current = new window.Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Órdenes de Trabajo',
                    data: data,
                    backgroundColor: 'rgba(59, 130, 246, 0.5)',
                    borderColor: 'rgba(59, 130, 246, 1)',
                    borderWidth: 1.5,
                    borderRadius: 6,
                    hoverBackgroundColor: 'rgba(59, 130, 246, 0.7)',
                    hoverBorderColor: 'rgba(59, 130, 246, 1)',
                }]
            },
            options: {
                animation: false,
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: {
                            color: 'rgba(255, 255, 255, 0.08)',
                            drawTicks: false
                        },
                        ticks: {
                            color: '#9ca3af',
                            font: {
                                size: 11
                            },
                            stepSize: 1
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#9ca3af',
                            font: {
                                size: 11,
                                weight: 'bold'
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        backgroundColor: '#1f2937',
                        titleColor: '#fff',
                        bodyColor: '#e5e7eb',
                        borderColor: '#374151',
                        borderWidth: 1,
                        padding: 10,
                        cornerRadius: 6,
                        displayColors: false
                    }
                }
            }
        });

        return () => {
            if (chartRef.current) {
                chartRef.current.destroy();
                chartRef.current = null;
            }
        };
    }, [chartJsLoaded, filteredWorkOrders]);

    return (
        <Card className="p-5 bg-gray-900/40 border border-gray-800">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">
                    Órdenes de Trabajo por Línea de Producción
                </h3>
            </div>
            <div className="h-64 relative w-full">
                <canvas ref={canvasRef}></canvas>
            </div>
        </Card>
    );
}
